import { render, staticRenderFns } from "./SettingsBotThemePreview.vue?vue&type=template&id=07f477b7&"
import script from "./SettingsBotThemePreview.vue?vue&type=script&lang=js&"
export * from "./SettingsBotThemePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports